export default {
  transactionRefundDialog: {
    title: '退款处理',
    info: '退款通常在5-10个工作日内处理，具体取决于支付方式和银行。',
    refundOnly: '仅退款',
    refundAndUnsubscribe: '退款并取消订阅',
    subscriptionRelated: '订阅相关',
    subscriptionRelatedTips: '该交易来自订阅。',
    remainingAmountTips: '部分退款（剩余 {amount} {currency}）',
  },
};
